<!-- Engaging Loader Display - Timeline with Collapsible Steps -->
<div class="engaging-loader" *ngIf="isStreaming || isCompleted">

  <!-- Streaming State: Show timeline with collapsible steps -->
  <div class="loader-streaming" *ngIf="isStreaming && !isCompleted">

    <!-- Timeline Steps (Collapsible) -->
    <div class="timeline-container" *ngIf="reasoningSteps.length > 0">
      <div class="timeline-step" 
           *ngFor="let step of reasoningSteps; let i = index; let last = last"
           [class.expanded]="isStepExpanded(i)">
        
        <!-- Timeline Visual: Circle and Line -->
        <div class="timeline-visual">
          <div class="timeline-circle"></div>
          <div class="timeline-line" *ngIf="!last"></div>
        </div>
        
        <!-- Step Content -->
        <div class="timeline-content">
          <!-- Clickable Action Header (Collapsed by Default) -->
          <button type="button" 
                  class="step-header" 
                  (click)="toggleStepExpanded(i)"
                  [attr.aria-expanded]="isStepExpanded(i)"
                  [attr.title]="isActionTruncated(step.action || '') ? (step.action || '') : null">
            <span class="step-action-text">{{ getTruncatedAction(step.action || '') }}</span>
            <span class="step-caret" [class.expanded]="isStepExpanded(i)">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
          
          <!-- Expandable Reasoning (Hidden by Default) -->
          <div class="step-reasoning-wrapper" [class.visible]="isStepExpanded(i)">
            <div class="step-reasoning-text">{{ step.reasoning }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Completed State: Collapsible Timeline -->
  <div class="loader-completed" *ngIf="isCompleted && !isStreaming">
    
    <!-- Timeline Steps (Collapsible) -->
    <div class="timeline-container completed" *ngIf="reasoningSteps.length > 0">
      <div class="timeline-step" 
           *ngFor="let step of reasoningSteps; let i = index; let last = last"
           [class.expanded]="isStepExpanded(i)">
        
        <!-- Timeline Visual: Circle and Line -->
        <div class="timeline-visual">
          <div class="timeline-circle"></div>
          <div class="timeline-line" *ngIf="!last"></div>
        </div>
        
        <!-- Step Content -->
        <div class="timeline-content">
          <!-- Clickable Action Header (Collapsed by Default) -->
          <button type="button" 
                  class="step-header" 
                  (click)="toggleStepExpanded(i)"
                  [attr.aria-expanded]="isStepExpanded(i)"
                  [attr.title]="isActionTruncated(step.action || 'Processing...') ? (step.action || 'Processing...') : null">
            <span class="step-action-text">{{ getTruncatedAction(step.action || 'Processing...') }}</span>
            <span class="step-caret" [class.expanded]="isStepExpanded(i)">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
          
          <!-- Expandable Reasoning (Hidden by Default) -->
          <div class="step-reasoning-wrapper" [class.visible]="isStepExpanded(i)">
            <div class="step-reasoning-text">{{ step.reasoning }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
